/* tslint:disable */
/* eslint-disable */
/**
 * Business Portal API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  BadRequest,
  GetCarTypes200ResponseInner,
  InternalServerError,
  ServiceUnavailable,
  Unauthorized,
  UnprocessableEntity,
} from '../models/index';
import {
    BadRequestFromJSON,
    BadRequestToJSON,
    GetCarTypes200ResponseInnerFromJSON,
    GetCarTypes200ResponseInnerToJSON,
    InternalServerErrorFromJSON,
    InternalServerErrorToJSON,
    ServiceUnavailableFromJSON,
    ServiceUnavailableToJSON,
    UnauthorizedFromJSON,
    UnauthorizedToJSON,
    UnprocessableEntityFromJSON,
    UnprocessableEntityToJSON,
} from '../models/index';

export interface GetCarTypesRequest {
    sort?: GetCarTypesSortEnum;
}

/**
 * 
 */
export class CarTypesApi extends runtime.BaseAPI {

    /**
     * 車種一覧情報取得
     */
    async getCarTypesRaw(requestParameters: GetCarTypesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<GetCarTypes200ResponseInner>>> {
        const queryParameters: any = {};

        if (requestParameters['sort'] != null) {
            queryParameters['sort'] = requestParameters['sort'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/car-types`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(GetCarTypes200ResponseInnerFromJSON));
    }

    /**
     * 車種一覧情報取得
     */
    async getCarTypes(requestParameters: GetCarTypesRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<GetCarTypes200ResponseInner>> {
        const response = await this.getCarTypesRaw(requestParameters, initOverrides);
        return await response.value();
    }

}

/**
 * @export
 */
export const GetCarTypesSortEnum = {
    Asc: 'asc',
    Desc: 'desc'
} as const;
export type GetCarTypesSortEnum = typeof GetCarTypesSortEnum[keyof typeof GetCarTypesSortEnum];
